module.exports = __webpack_public_path__ + "fromBrideToMother-we-w.1644be45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-we-w.jpg
// module id = FfB1
// module chunks = 0